import {
    TablePagination,
    Theme
} from "@mui/material";
import {
    CaretDownIcon,
    PaginationNextIcon,
    PaginationPreviousIcon
} from "../../../../assets/SvgIcons";

export default function TablePaginationComponent(
    {
        tableDataCount,
        handlePageChange,
        handleRowsPerPageChange,
        rowsPerPageOptions = [10, 20, 30],
        rowsPerPage = 10,
        currentPage = 0
    }: {
        tableDataCount: number,
        handlePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void,
        handleRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        rowsPerPageOptions?: number[]
        rowsPerPage?: number;
        currentPage?: number;
    }
): JSX.Element {
    return (
        <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={tableDataCount}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            slotProps={{
                select: {
                    IconComponent: CaretDownIcon
                }
            }}
            // slots={{
            //     actions: {
            //         nextButtonIcon: PaginationNextIcon,
            //         previousButtonIcon: PaginationPreviousIcon
            //     }
            // }}
            sx={(theme: Theme) => ({
                "& .MuiTablePagination-toolbar": {
                    "& .MuiTablePagination-selectLabel": {
                        ...theme.typography.subtitle_400,
                        color: theme.palette.text.primary,
                    },
                    "& .MuiTablePagination-displayedRows": {
                        ...theme.typography.subtitle_400,
                        color: theme.palette.text.primary,
                        marginBottom: "13px"
                    },
                    "& .MuiTablePagination-input": {
                        "& .MuiTablePagination-select": {
                            paddingTop: "10px",
                            ...theme.typography.subtitle_400,
                            color: theme.palette.text.primary
                        },
                        "& .MuiTablePagination-selectIcon": {
                            color: theme.palette.text.primary
                        }
                    },
                }
            })}
        />
    )
}